module.exports = __webpack_public_path__ + "asset/image/boltIcon-9acb.svg";